import { useCallback } from "react";

import { useAction } from "@/hooks/shared";
import { getCurrentUserHandler, loginHandler } from "@/services";
import type { LoginRequestType, LoginResponseType } from "@/types";
import { saveUserHandler } from "@/utils";

export const useLogin = () => {
    const action = useAction<[LoginRequestType], LoginResponseType>(loginHandler);

    const runHandler = useCallback(
        async (request: LoginRequestType) => {
            const result = await action.onRun(request);

            saveUserHandler(result.user);

            try {
                const fresh = await getCurrentUserHandler();

                saveUserHandler(fresh);

                return {
                    ...result,
                    user: fresh,
                };
            } catch {
                return result;
            }
        },
        [action],
    );

    return {
        ...action,
        onRun: runHandler,
    };
};
